<template>
	<div class="toolbar flex align-center justify-space-between">

		<div class="box-left box grow flex">
         <div class="title">Administration Portal</div>

		</div>
		<div class="box-right flex align-center pl-8">

			<span class="username" v-if="this.$store.state.profile != null">{{this.$store.state.profile.name}}</span>
			<el-button type="text" class="username" v-if="this.$store.state.profile != null" @click="logout">Logout</el-button>
		</div>
	</div>
</template>

<script>


import {UserService} from "../api/modules/userManagement/services/UserService";
import {StoreProxy} from "../api/common/StoreProxy";
import {AuthService} from "../api/AuthService";

export default {
	name: 'Toolbar',
	data() {
		return {
			popoverWidth: 300,
			fullscreen: false,
			lang: 'us',
		}
	},
	methods: {
		onCommandLang(lang) {
			if(lang.charAt(0) === '/')
				this.onCommand(lang)
			else
				this.lang = lang
		},
		onCommand(path) {
			this.$router.push(path)
		},
		toggleSidebar() {
			this.$emit('toggle-sidebar')
		},
		resizePopoverWidth() {
			if(window.innerWidth <= 768) {
				this.popoverWidth = 250	
			} else {
				this.popoverWidth = 300	
			}
		},
		logout(){
			let vm = this;
			let service = new AuthService();
			service.logout(StoreProxy.getAuth(this.$store)).then(() => {
				vm.$router.push("/login");
			}).catch(e => {

				this.$notify.error({
					title: 'Internal Error',
					message: 'Server error when logging out this session.'
				});

				if (e != null){
					console.error(e);
				}
			})
		}

	},
	components: {



	},
	mounted() {
		this.fullscreen = this.$fullscreen.getState();
		this.resizePopoverWidth();
		window.addEventListener('resize', this.resizePopoverWidth);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.resizePopoverWidth);
	}
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_variables';
@import '../assets/scss/_mixins';

.toolbar {

	padding: 0;
	box-sizing: border-box;
	background-color: $header-background-color;

	.title {
		font-size:x-large;
		font-weight: normal;
		color: #ffffff;
	}

	.username {
		//margin-left: 20px;
		font-weight: bold;
		//@include text-bordered-shadow();
		
		color: white;
		margin-right: 10px;
	}


	}




@media (max-width: 650px) {
	.toolbar {
		.username {
			display: none;
		}
	}
}

@media (max-width: 768px) {
	.toolbar {
		padding: 0 10px;

		.toggle-sidebar {
			display: block;
			opacity: 1;
		}

		.fullscreen-button {
			display: none;
		}
	}
}
</style>
